import { z } from 'zod';

export const inviteSchema = z.object({
  externalId: z
    .string()
    .nullish()
    .default(null)
    .transform((val) => val || null),
  fullName: z.string().min(2, { message: 'Full name is required.' }),
  email: z.string().email(),
  roles: z
    .array(z.object({ label: z.string(), value: z.number() }))
    .min(1, { message: 'At least one role is required.' }),
});

export type InviteForm = z.infer<typeof inviteSchema>;
